<template>
  <div>
    <ul class="pagination">
      <!-- <li>
        <a @click="firstPage" class="pagination-first">
          <i class="fa fa-angle-double-left"></i>FIRST
        </a>
      </li>-->
      <li>
        <a @click="prevPage" class="previous">
          <span class="sr-only">이전페이지</span>
        </a>
      </li>
      <li>
        <span class="now">{{currentPage}}</span>
      </li>
      <li>
        <span class="slash">/</span>
      </li>
      <li>
        <span class="last">{{totalPage}}</span>
      </li>
      <li>
        <a @click="nextPage" class="next">
          <span class="sr-only">다음페이지</span>
        </a>
      </li>
      <!-- <li>
        <a @click="lastPage" class="pagination-last">
          <i class="fa fa-angle-double-right"></i>LAST
        </a>
      </li>-->
    </ul>
  </div>
</template>

<script>
export default {
  props: ["current-page", "total-page"],
  data() {
    return {};
  },
  methods: {
    nextPage() {
      this.$emit("next-page");
    },
    prevPage() {
      this.$emit("prev-page");
    },
    firstPage() {
      this.$emit("first-page");
    },
    lastPage() {
      this.$emit("last-page");
    }
  }
};
</script>

<style>
.pagination {
  display: flex;
  list-style: none;
  color: #000;
  text-align: center;
  justify-content: center;
}

.pagination .now {
}
.pagination .slash {
  opacity: 0.3;
}
.pagination .last {
  opacity: 0.5;
}
.pagination li {
  margin: 0 5px;
}
.pagination li a.previous,
.pagination li a.next {
  display: block;
  width: 25px;
  height: 25px;
  border: solid 1px #d2d2d2;
  border-radius: 0;
  text-align: center;
  background-size: auto 15px;
  background-repeat: no-repeat;
  background-position: center center;
}
.pagination .btn-border-default .vs-button-text {
  color: #d2d2d2;
}

.pagination li a.previous {
  background-image: url("../../assets/icon_white_arrow_left.png");
}
.pagination li a.next {
  background-image: url("../../assets/icon_white_arrow_right.png");
}
</style>
